import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import * as React from 'react';

import QueueInfoImage from '../images/queueinfoimage.png';
import TableInfoImage from '../images/tableinfoimage.jpg';
import BlobInfoImage from '../images/blobinfoimage.png';
import { Resources } from './resources';

interface OutputInfoSectionState {
    isQueueCollapsed: boolean;
    isTableCollapsed: boolean;
    isBlobCollapsed: boolean;
}

const expandIcon: IIconProps = { iconName: 'ChevronDownMed' };
const collapseIcon: IIconProps = { iconName: 'ChevronUpMed' };

export class OutputInfoSection extends React.Component<{}, OutputInfoSectionState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            isQueueCollapsed: true,
            isTableCollapsed: true,
            isBlobCollapsed: true      
        };
    }

    private _onQueueButtonClicked = (): void => {
        const prevState = this.state.isQueueCollapsed;
        this.setState({
            isQueueCollapsed: !prevState
        });
    }

    private _onTableButtonClicked = (): void => {
        const prevState = this.state.isTableCollapsed;
        this.setState({
            isTableCollapsed: !prevState
        });
    }

    private _onBlobButtonClicked = (): void => {
        const prevState = this.state.isBlobCollapsed;
        this.setState({
            isBlobCollapsed: !prevState
        });
    }

    render(): JSX.Element {
        return (
            <div className="calc-output-info">
                <Label className="calc-output-info-label">{Resources.OUTPUT_INFO_LABEL}</Label>
                <a className="calc-output-info-pricing-calculator-link" href={Resources.AZURE_PRICING_CALCULATOR_LINK} target="_blank" rel="noreferrer">{Resources.AZURE_PRICING_CALCULATOR_LINK_LABEL}</a>
                <ul>
                    <div className="calc-output-info-queue-section">
                        <li><Label className="calc-output-info-queue-label">{Resources.OUTPUT_INFO_QUEUE_LABEL}​​</Label></li>
                        <IconButton ariaLabel={this.state.isQueueCollapsed ? "expand" : "collapse"} className="queue-info-expand" iconProps={this.state.isQueueCollapsed ? expandIcon : collapseIcon} onClick={this._onQueueButtonClicked}/>
                    </div>
                    {!this.state.isQueueCollapsed
                        ? <div className="calc-output-queue-info">
                            <ol className="calc-output-queue-info-list">
                                <li>{Resources.OUTPUT_INFO_QUEUE_STEP1}</li>
                                <li>{Resources.OUTPUT_INFO_QUEUE_STEP2}</li>
                                <li>{Resources.OUTPUT_INFO_QUEUE_STEP3}</li>
                                <li>{Resources.OUTPUT_INFO_QUEUE_STEP4}</li>
                                <li>{Resources.OUTPUT_INFO_QUEUE_STEP5}</li>
                            </ol>
                            <img alt="queueinfoimage" className="calc-queue-image" src={QueueInfoImage}></img>
                        </div>
                        : undefined
                    }
                    <div className="calc-output-info-table-section">
                        <li><Label className="calc-output-info-table-label">{Resources.OUTPUT_INFO_TABLE_LABEL}​​</Label></li>
                        <IconButton ariaLabel={this.state.isTableCollapsed ? "expand" : "collapse"} className="table-info-expand" iconProps={this.state.isTableCollapsed ? expandIcon : collapseIcon} onClick={this._onTableButtonClicked} />
                    </div>
                    {!this.state.isTableCollapsed
                        ? <div className="calc-output-table-info">
                            <ol className="calc-output-table-info-list">
                                <li>{Resources.OUTPUT_INFO_TABLE_STEP1}</li>
                                <li>{Resources.OUTPUT_INFO_TABLE_STEP2}</li>
                                <li>{Resources.OUTPUT_INFO_TABLE_STEP3}</li>
                                <li>{Resources.OUTPUT_INFO_TABLE_STEP4}</li>
                                <li>{Resources.OUTPUT_INFO_TABLE_STEP5}</li>
                            </ol>
                            <img alt="tableinfoimage" className="calc-table-image" src={TableInfoImage}></img>
                        </div>
                        : undefined
                    }
                    <div className="calc-output-info-blob-section">
                        <li><Label className="calc-output-info-blob-label">{Resources.OUTPUT_INFO_BLOB_LABEL}</Label></li>
                        <IconButton ariaLabel={this.state.isBlobCollapsed ? "expand" : "collapse"} className="blob-info-expand" iconProps={this.state.isBlobCollapsed ? expandIcon : collapseIcon} onClick={this._onBlobButtonClicked} />
                    </div>
                    {!this.state.isBlobCollapsed
                        ? <div className="calc-output-blob-info">
                            <ol className="calc-output-blob-info-list">
                                <li>{Resources.OUTPUT_INFO_BLOB_STEP1}</li>
                                <li>{Resources.OUTPUT_INFO_BLOB_STEP2}</li>
                                <li>{Resources.OUTPUT_INFO_BLOB_STEP3}</li>
                                <li>{Resources.OUTPUT_INFO_BLOB_STEP4}</li>
                                <li>{Resources.OUTPUT_INFO_BLOB_STEP5}</li>
                            </ol>
                            <img alt="blobinfoimage" className="calc-blob-image" src={BlobInfoImage}></img>
                        </div>
                        : undefined
                    }
                </ul>
            </div>
        );
    }
}